import { RelyingPartyDetailsState } from "@idw-types/state/relying-party-details-state";
import { RelyingPartyDetailsActionTypes, RelyingPartyDetailsActions } from "../actions/relying-party-details-actions";

export const initialRelyingPartyDetailsState: RelyingPartyDetailsState = {
    relyingParty: {
        relyingParty: null,
        isLoading: false
    }
};

export const relyingPartyDetailsReducer = (
    state: RelyingPartyDetailsState = initialRelyingPartyDetailsState,
    action: RelyingPartyDetailsActions
): RelyingPartyDetailsState => {
    switch (action.type) {
        case RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS_LOADING:
            return {
                ...state,
                relyingParty: {
                    ...(action.payload.isLoading
                        ? { ...initialRelyingPartyDetailsState.relyingParty }
                        : { ...state.relyingParty }),
                    isLoading: action.payload.isLoading
                }
            };
        case RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS:
            return {
                ...state,
                relyingParty: {
                    relyingParty: action.payload.relyingParty,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};